<template>
  <div class="searchBox">
    <el-form
      ref="searchForm" v-model="queryForm" :inline="false"
      label-position="top"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item size="small">
            <template slot="label">
              <el-select
                v-model="queryForm.params.searchNumberType"
                :placeholder="$t('orderDetails.pleaseChoose')"
                :style="IsWidth"
                class="selectClass"
                size="small"
                @change="handleChangeLable"
              >
                <!--运单号-->
                <el-option key="1" :label="$t('orderCenterCont.anjunWaybillNumber')" value="1" />
                <!--扫描单号-->
                <el-option key="8" :label="$t('GlobalSetObj.ScanNumber')" value="8" />
                <!--服务商物流单号-->
                <el-option key="5" :label="$t('GlobalSetObj.serviceLogistics')" value="5" />
                <!-- 安骏订单号 -->
                <el-option key="15" :label="$t('GlobalSetObj.anJunOrderNumber')" value="15" />
                <!--客户订单号-->
                <el-option key="2" :label="$t('newOrder.PlatformOrderNumber')" value="2" />
                <!--揽收袋号-->
                <el-option key="3" :label="$t('orderCenterCont.PickUpBagNumber')" value="3" />
                <!--中转仓袋号-->
                <el-option key="4" :label="$t('orderCenterCont.TransitBinBagNumber')" value="4" />
                <!--子包号-->
                <el-option key="7" :label="$t('orderCenterCont.SubpackageNumber')" value="7" />
                <!-- CTE发票号 -->
                <el-option key="17" :label="$t('driver.cteInvoiceNumber')" value="17" />
                <!--NFE发票号-->
                <el-option key="10" :label="'NFE' + $t('newOrder.InvoiceNumber')" value="10" />
                <!--发票密钥-->
                <el-option key="9" :label="'NFE' + $t('newOrder.InvoiceKey')" value="9" />
                <!-- 收件人CPF -->
                <el-option key="16" :label="$t('driver.recipientCPF')" value="16" />
              </el-select>
            </template>
            <el-input
              v-model="searchNumberStr"
              :placeholder="$t('newOrder.PreciseSearch1')"
              :rows="2"
              style="margin-top: 3px"
              type="textarea"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--创建时间-->
          <el-form-item prop="searchTimeType" size="small">
            <template slot="label">
              <el-select
                v-model="queryForm.params.searchTimeType"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                :style="IsWidthTime"
                class="selectClass"
                @change="SwitchTimeType"
              >
                <!--创建时间-->
                <el-option key="1" :label="$t('newOrder.createTime')" value="1" />
                <!--客户出仓时间-->
                <el-option key="5" :label="$t('orderCenterCont.customerDeliveryTime')" value="5" />
                <!--转运入库时间-->
                <el-option key="3" :label="$t('newOrder.TransitInboundTime')" value="3" />
                <!--转运出库时间-->
                <el-option key="4" :label="$t('newOrder.shipmentTime')" value="4" />
                <!--网点入库时间-->
                <!--                <el-option key="6" :label="$t('newOrder.StorageTimeOutlets')" value="6" />-->
                <!--                网点派件时间-->
                <el-option key="7" :label="$t('orderCenterCont.deliveryTime')" value="7" />
                <!--签收时间-->
                <el-option key="2" :label="$t('orderCenterCont.SigningTime')" value="2" />
              </el-select>
            </template>
            <el-date-picker
              v-model="timeValue"
              :default-time="['00:00:00', '23:59:59']"
              :end-placeholder="$t('operationCenter.endDate')"
              :format="$i18n.locale === 'zh' ? zhDate : ptDate"
              :picker-options="pickerOptions"
              :start-placeholder="$t('operationCenter.startDate')"
              range-separator="~"
              size="small"
              style="width: 100%; margin-top: 3px"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="handleTime"
              @input="changeInput($event)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--运单状态-->
          <el-form-item :label="$t('newOrder.waybillStatus')">
            <el-select
              v-model="queryForm.params.waybillStatus"
              :placeholder="$t('GlobalSetObj.all')"
              clearable
              collapse-tags
              filterable
              multiple
              size="small"
              style="width: 100%"
              @change="selectStatus"
            >
              <el-option
                v-for="(item, ind) in waybillStatusList"
                :key="ind"
                :label="item.label"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--客户-->
          <el-form-item :label="$t('newOrder.CustomerName')" name="customerIds">
            <el-select
              v-model="queryForm.params.customerIds"
              :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
              :remote-method="getCustomerPage"
              clearable
              filterable
              multiple
              remote
              reserve-keyword
              size="small"
              style="width: 100%"
              @clear="getCustomerPage('')"
              @focus="getCustomerPageFuc"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.customerAlias + '(' + item.username + ')'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <div style="margin-top: 28px">
            <!--搜索-->
            <el-button size="small" type="primary" @click="getData(1)">{{ $t('newOrder.search') }}
            </el-button>
            <!--清空当前内容-->
            <el-button
              size="small" style="margin-left: 10px" type="info"
              @click="resetForm"
            >
              {{ $t('customerManagements.reset') }}
            </el-button>
            <span class="SearchExpansion" @click="show3 = !show3">
              <i v-if="show3" class="iconfont icon-a-ziyuan410" />
              <i v-else class="iconfont icon-a-ziyuan310" />
            </span>
          </div>
        </el-col>
      </el-row>
      <el-row v-show="show3" :gutter="10">
        <el-col :span="4">
          <!--货物类型-->
          <el-form-item :label="$t('placeOrder.cargoType')" size="small">
            <el-select v-model="queryForm.params.cargoType" style="width: 100%">
              <el-option :label="$t('GlobalSetObj.all')" value="" />
              <el-option :label="$t('placeOrder.normal01')" :value="0" />
              <el-option :label="$t('GlobalSetObj.big01')" :value="1" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--包裹类型-->
          <el-form-item :label="$t('placeOrder.packageType')" size="small">
            <el-select v-model="queryForm.params.orderPackageType" style="width: 100%">
              <el-option :label="$t('GlobalSetObj.all')" :value="0" />
              <el-option :label="$t('placeOrder.zhifa')" :value="1" />
              <el-option :label="$t('orderCenterCont.hedan')" :value="2" />
              <el-option :label="$t('mdfeTranslate.multipleItemsPerOrder')" :value="5" />
              <el-option :label="$t('GlobalSetObj.big01')" :value="4" />
              <el-option :label="$t('orderCenterCont.other')" :value="3" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$t('collectionCenter.tipoTitle')" size="small">
            <el-select
              v-model="queryForm.params.isReverse"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              clearable
              style="width: 100%"
            >
              <el-option :label="$t('collectionCenter.tudo')" :value="null" /><!-- 全部 -->
              <el-option :label="$t('collectionCenter.originalOrder')" :value="0" /><!-- 原单 -->
              <el-option
                :label="$t('collectionCenter.originalOrderReturned')"
                :value="2"
              /><!-- 原单退回 -->
              <el-option
                :label="$t('collectionCenter.newOrderReturned')"
                :value="1"
              /><!-- 新单退回 -->
              <el-option
                :label="$t('trajectory.originalOrderReturn_D2D')"
                :value="3"
              /><!-- 原单退回D2D -->
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--商户号-->
          <el-form-item :label="$t('collectionCenter.merchantCode')" size="small">
            <el-input
              v-model.trim="queryForm.params.merchantCode"
              :placeholder="$t('orderDetails.pleaseInput')"
              clearable
              size="small"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--商户名称-->
          <el-form-item :label="$t('collectionCenter.MerchantName')" size="small">
            <el-select
              v-model="queryForm.params.merchantCodeList"
              :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
              :remote-method="getMerchantList"
              clearable
              collapse-tags
              filterable
              multiple
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in merchantList"
                :key="index"
                :label="`${item.merchantName} - ${item.merchantCode}`"
                :value="item.merchantCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--实际揽收网点-->
          <el-form-item :label="$t('newOrder.ActualCollection')" size="small">
            <el-select
              v-model="queryForm.params.collectStationId"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              :remote-method="remoteGetSiteList"
              clearable
              filterable
              remote
              reserve-keyword
              style="width: 100%"
              @focus="remoteGetSiteList('')"
            >
              <el-option
                v-for="item in siteList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-show="show3" :gutter="10">
        <el-col :span="4">
          <!--实际派送网点-->
          <el-form-item>
            <template slot="label">
              <el-select
                v-model="queryForm.params.deliverWarehouseStationType"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                class="selectClass"
                size="small"
              >
                <el-option :label="$t('GlobalSetObj.entrega')" value="1" />
                <el-option :label="$t('GlobalSetObj.infeatSite')" value="2" />
              </el-select>
            </template>
            <el-select
              v-model="queryForm.params.deliverStationId"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              :remote-method="remoteGetSiteList"
              clearable
              filterable
              remote
              reserve-keyword
              size="small"
              style="width: 100%"
              @focus="remoteGetSiteList('')"
            >
              <el-option
                v-for="item in siteList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--预派送网点-->
          <el-form-item :label="$t('GlobalSetObj.preEntrega')" size="small">
            <el-select
              v-model="queryForm.params.preDeliverStationId"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              :remote-method="remoteGetSiteList"
              clearable
              filterable
              remote
              reserve-keyword
              style="width: 100%"
              @focus="remoteGetSiteList('')"
            >
              <el-option
                v-for="item in siteList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--派送员-->
          <el-form-item :label="$t('orderCenterCont.deliveryPerson')" size="small">
            <el-select
              v-model="queryForm.params.deliveryManName"
              :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
              :remote-method="getallDriver"
              clearable
              filterable
              remote
              style="width: 100%"
              @focus="getallDriver('')"
            >
              <el-option
                v-for="item in drvierList"
                :key="item.id"
                :label="item.username"
                :value="item.username"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--收件人邮编-->
          <el-form-item :label="$t('receivablePayable.RecipientzipCode')" size="small">
            <el-input
              v-model.trim="queryForm.params.receiveZipcode"
              :placeholder="$t('orderDetails.pleaseInput')"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--收件人名字-->
          <el-form-item :label="$t('receivablePayable.receiveName')" size="small">
            <el-input
              v-model.trim="queryForm.params.receiveName"
              :placeholder="$t('orderDetails.pleaseInput')"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--收件人州-->
          <el-form-item :label="$t('newOrder.RecipientState')" size="small">
            <el-select
              v-model="queryForm.params.receiveStateList"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in StateList"
                :key="item.id"
                :label="item.label"
                :value="item.label"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { providerchannelall } from '@/api/logisticsOrders';
import { apiCustomerPage, apimerchantName } from '@/api/customer';
import dayjs from 'dayjs';
import { waybillStatusList } from '@/utils/enumData';
import { siteFuzzyQuery } from '@/api/lanshou';
import { getLgAreaListData } from '@/api/orderApi';
import { signRescissiongetPmUserList } from '@/api/resources';

export default {
  name: 'Search',
  props: {
    pagination: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      show3: false,
      queryForm: {
        pageSize: 10,
        number: 1,
        params: {
          searchTimeType: '1',
          waybillStatus: [],
          createStartTime: '',
          createEndTime: '',
          waybillNumber: '',
          searchNumberType: '1',
          deliverWarehouseStationType: '1',
          // providerChannelIdList: [],
          customerIds: [],
          deliverStationId: '',
          collectStationId: '', // 实际揽收网点
          preDeliverStationId: '', // 预派送网点
          orderPackageType: 0,
          cargoType: '',
          merchantCode: '',
          merchantCodeList: [],
          deliveryManName: '', // 派件人
          accountType: 0,
          receiveStateList: [],
          receiveName: '',
          receiveZipcode: '',
          isReverse: null
        }
      },
      searchNumberStr: '',
      searchNumberList: [],
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      // 是否格式化成巴西时间
      isTormat: false,
      // 查询列表数据
      selectLabel: [
        { id: 1, label: this.$t('newOrder.waybillNumber'), value: 1 },
        { id: 2, label: this.$t('newOrder.PlatformOrderNumber'), value: 2 },
        // { id: 3, label: this.$t('orderCenterCont.PickUpBagNumber'), value: 3 },
        { id: 4, label: this.$t('orderCenterCont.TransitBinBagNumber'), value: 4 },
        { id: 5, label: this.$t('GlobalSetObj.serviceLogistics'), value: 5 },
        // { id: 6, label: this.$t('newOrder.InvoiceNumber'), value: 6 },
        { id: 7, label: this.$t('orderCenterCont.SubpackageNumber'), value: 7 }
      ],
      searchNameObj: { id: 1, label: this.$t('newOrder.waybillNumber'), value: 1 },
      channelall: [],
      customerList: [], // 客户列表
      timeValue: [],
      drvierList: [], // 派件员
      siteList: [], // 网点列表
      selectDate: '',
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = '';
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      },
      waybillStatusList: waybillStatusList,
      StateList: [],
      merchantList: [],
      searMerchantName: ''
    };
  },
  computed: {
    IsWidth() {
      return {
        width: this.isTormat ? '250px' : '130px'
      };
    },
    IsWidthTime() {
      return {
        width: this.isTormat ? '200px' : '150px'
      };
    }
  },
  watch: {
    pagination: {
      handler(newVal, oldVal) {
        console.log(1);
        this.queryForm.pageSize = newVal.pageSize;
        this.queryForm.pageNumber = newVal.pageNumber;
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getallDriver();
    // 获取网点前十页
    this.remoteGetSiteList();
    this.getTimer();
    this.getAddress();
    this.getAllProviderChannel();
  },
  methods: {
    // 重置
    resetForm() {
      this.queryForm.pageNumber = 1;
      this.searchNumberStr = '';
      this.searMerchantName = '';
      this.queryForm.params = {
        searchTimeType: '1',
        waybillStatus: [],
        createStartTime: '',
        createEndTime: '',
        waybillNumber: '',
        searchNumberType: '1',
        deliverWarehouseStationType: '1',
        // providerChannelIdList: [],
        customerIds: [],
        deliverStationId: '',
        collectStationId: '', // 实际揽收网点
        preDeliverStationId: '', // 预派送网点
        orderPackageType: 0,
        cargoType: '',
        merchantCode: '',
        merchantCodeList: [],
        deliveryManName: '', // 派件人
        accountType: 0,
        receiveStateList: [],
        receiveName: '',
        receiveZipcode: '',
        isReverse: null
      };
      this.getTimer();
      this.getData(10);
    },
    // 获取最近一星期时间
    getTimer() {
      const day = new Date();
      const brazilTime = day.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
      const today = dayjs(brazilTime).format('YYYY-MM-DD');
      // const oneWeekAgo = dayjs(brazilTime).subtract(1, 'week').format('YYYY-MM-DD');
      this.timeValue = [today + ' 00:00:00', today + ' 23:59:59'];
      this.queryForm.params.createStartTime = this.timeValue[0];
      this.queryForm.params.createEndTime = this.timeValue[1];
    },
    changeInput(val) {
      this.$emit('input', val);
    },
    // 修改时间
    handleTime(val) {
      if (val) {
        const startDate = dayjs(val[0]);
        const endDate = dayjs(val[1]);
        // 计算天数差（取绝对值，确保顺序不影响结果）
        const daysDiff = Math.abs(endDate.diff(startDate, 'day'));
        // 判断是否超过31天
        const isOver31Days = daysDiff > 31;
        if (isOver31Days) {
          this.$message.error(this.$t('tablePrice.timeRangeLimit'));
          this.getTimer();
        } else {
          this.queryForm.params.createStartTime = val[0];
          this.queryForm.params.createEndTime = val[1];
        }
      } else {
        this.queryForm.params.createStartTime = '';
        this.queryForm.params.createEndTime = '';
      }
      // this.$emit('searchFun', this.queryForm, this.searchNumberList);
    },
    // 获取所有渠道
    getAllProviderChannel() {
      this.channelall = [];
      providerchannelall().then((res) => {
        if (res.code === 200) {
          console.log('获取所有渠道', res.data);
          this.channelall = res.data;
        }
      });
    },
    // 获取派送员
    getallDriver(name) {
      const data = {
        operateUserName: name
      };
      signRescissiongetPmUserList(data).then((res) => {
        if (res.code === 200) {
          console.log('获取派送员', res.data);
          this.drvierList = res.data;
        }
      });
    },
    /**
     * @description 分页查询网点列表
     * @param val
     */
    remoteGetSiteList(val) {
      const value = val || '';
      siteFuzzyQuery(value).then((res) => {
        if (res.code === 200) {
          this.siteList = res.data;
        }
      });
    },
    // 切换时间
    SwitchTimeType(val) {
      this.queryForm.params.searchTimeType = val;
    },
    handleChangeLable(val) {
      const index = val - 1;
      this.searchNameObj = this.selectLabel[index];
    },
    selectStatus(val) {
      console.log(val, 'valvalselectStatus');
      console.log(val.indexOf(0), 'STATUS');
      if (val.indexOf(0) !== -1) {
        this.queryForm.params.waybillStatus = [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 20, 21, 22
        ];
      }
      // if (val.includes(3)) {
      //   val.push(19);
      // }
    },
    // 查询单号整理
    searchNumberCollation() {
      if (this.searchNumberStr) {
        // 单号格式化，去除空格
        const orderNumber = this.searchNumberStr.split(/[(\r\n)\r\n]+/);
        const numberList = [];
        orderNumber.map((item) => {
          if (item) {
            numberList.push(item.trim());
          }
        });
        this.searchNumberList = numberList;
      } else {
        this.searchNumberList = [];
      }
    },
    // 回车查询
    searchFun() {
      this.searchNumberCollation();
      this.queryForm.number = this.pagination.number;
      this.queryForm.pageSize = this.pagination.pageSize;
      if (this.searchNumberList.length > 0) {
        this.timeValue = [];
        this.queryForm.params.createStartTime = '';
        this.queryForm.params.createEndTime = '';
      }
      this.$emit('searchFun', this.queryForm, this.searchNumberList);
    },
    // 搜索组件点击搜索按钮事件
    getData(type) {
      this.searchNumberCollation();
      this.queryForm.number = this.pagination.number;
      this.queryForm.pageSize = this.pagination.pageSize;
      if (this.searchNumberList.length > 0) {
        this.timeValue = [];
        this.queryForm.params.createStartTime = '';
        this.queryForm.params.createEndTime = '';
      }
      this.$emit('searchFun', this.queryForm, this.searchNumberList, type);
    },
    /**
     * @description 分页获取客户列表
     * @param { string } name 客户名称
     */
    getCustomerPage(name) {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    getCustomerPageFuc() {
      if (this.customerList.length === 0) {
        this.getCustomerPage('');
      }
    },
    // 获取商户列表
    getMerchantList(val = '', flag) {
      const data = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          merchantName: ''
        }
      };
      if (flag) {
        if (this.merchantList.length === 0) {
          apimerchantName(data).then((res) => {
            if (res.code === 200) {
              this.merchantList = res.data.records;
            }
          });
        }
      } else {
        data.params.merchantName = val;
        apimerchantName(data).then((res) => {
          if (res.code === 200) {
            this.merchantList = res.data.records;
          }
        });
      }
    },
    // 州
    getAddress() {
      // level 0 州    1 城市   2 地区
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.searchBox >>> .selectClass .el-input__inner {
  font-weight: 600 !important;
}

.SearchExpansion {
  padding: 4px 20px;
  font-size: 20px;
  cursor: pointer;
  border: 1px solid #cccccc;
  border-radius: 5px;
  margin-left: 10px;
}
</style>
